import AppConsts from "./appconst";
import Util from "./util";
class VideoPlayerHelper {
  init() {
    Util.loadScript("https://unpkg.com/v-video-embed/dist/video-embed.min.js");
  }
}
export default new VideoPlayerHelper();
